/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import ActivityListView from '../../view/pages/activity/ListView'
import ActivityAction from '../../action/activity'
import ActivitiesStore from '../../store/activity/ActivitiesStore'
import ActivityPaginationStore from '../../store/activity/ActivityPaginationStore'

class ListContainer extends Component {
  static getStores() {
    return [ActivitiesStore, ActivityPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      activities: ActivitiesStore.getState(),
      pagination: ActivityPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    await ActivityAction.onSearch(this.state.pagination)
    NProgress.done()
  }

  render() {
    return ActivityListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
